<template>
  <div class="box">
    <el-tree :highlight-current='true' :data="treeData" node-key="id" empty-text='暂无章节，请点击右上角更换条件！'
      :props="defaultProps" accordion @node-click="handleNodeClick">
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "TreeNav",
  props: {
    treeData: {
      type: Array
    },
    defaultProps: {
      type: Object
    }
  },

  methods: {
    handleNodeClick(data) {
      this.$emit("handleNodeClick", data);
    }
  }
};
</script>

<style lang='less' scoped>
.box {
  width: 100%;
  display: flex;
  flex-direction: column;

  .el-tree {
    padding-bottom: 10px;

    /deep/.el-tree__empty-text {
      width: 100%;
      height: 100%;
      font-size: 16px;
    }

    /deep/.el-tree-node__content:hover {
      background-color: #24ba58;
      color: #fff;
    }

    /deep/.el-tree-node.is-current > .el-tree-node__content {
      background-color: #24ba58;
      color: #fff;
    }

    /deep/.el-tree-node__label {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /deep/.el-tree-node__label:hover {
      overflow: visible;
      text-overflow: none;
    }
  }
}
</style>